import { AppDispatch, GetState } from '../store';
import { handleError } from '../slices/errors.slice';
import { UpdateReportError } from '../../types/check/errors';
import { initializeState } from './init-state';
import { initializeProcessingStep } from './init-current-step';
import { checkIntegrationService } from '../../services/CheckIntegrationService';

export const ALREADY_PROCESSED_ERROR = 'Check is being processed, editing user data at this stage is not allowed';

export const fetchIntegrationData = () => {
	return async (dispatch: AppDispatch, getState: GetState) => {
		try {
			const response = await checkIntegrationService.fetchIDAustriaLogin();

			if (response.data.errors) {
				dispatch(processUpdateErrors(response.data.errors));
				return;
			}

			dispatch(initializeProcessingStep());
		} catch (error: any) {
			dispatch(handleError(error));
		}
	};
};

export function processUpdateErrors(errors: Array<string>) {
	return (dispatch: AppDispatch) => {
		const error = errors[0];

		if (error === ALREADY_PROCESSED_ERROR) {
			dispatch(initializeState());
			return;
		}

		dispatch(handleError(new UpdateReportError(errors)));
	};
}
